import { Component, EventEmitter, Output } from '@angular/core';
import { SOLICITATION_LOOKUP_KEYS } from '../../../../../../shared/models/outreach-lookup-keys.constants';

@Component({
  selector: 'app-key',
  templateUrl: './key.component.html',
  styleUrls: ['./key.component.scss'],
  standalone: false,
})
export class KeyComponent {
  @Output() closeMenuSignal = new EventEmitter();

  defaultKeys = SOLICITATION_LOOKUP_KEYS;

  public closeMenu(): void {
    this.closeMenuSignal.emit();
  }
}
